import FlatCard from "../../cards/flatcard/FlatCard";
import "./contactForm.css";
import myLinks from "../../Object Files/links";
import Form from "./Form";
import { motion } from "framer-motion";
import { useRef } from "react";

const leftVariant = {
  hidden: { x: -40, opacity: 0 },
  show: { x: 0, opacity: 1, transition: { duration: 0.45 } },
};
const rightVariant = {
  hidden: { x: 40, opacity: 0 },
  show: { x: 0, opacity: 1, transition: { duration: 0.45 } },
};

const ContactForm = ({ contactRef }) => {
  const nameRef = useRef();

  const handleClick = () => {
    nameRef.current?.focus();
  };

  return (
    <section id="contact" ref={contactRef}>
      <div className="max-width flex column contact__cont_main">
        <header className="project-section-header">
          <h1 className="project-head-text alt-text">Contact</h1>
          <hr className="short-hr project-hr right_hr" />
        </header>
        <motion.div
          className="max_content"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          <FlatCard
            customClass="contact-form-cont"
            style={{ overflow: "hidden" }}
          >
            <motion.div className="contact-sub-div" variants={rightVariant}>
              <h2 className="contact-head-text">
                Let&apos;s <span className="alt-text-yellow">build</span> your
                next <span className="alt-text-yellow">backend</span> or product.
              </h2>

              <button type="button" onClick={handleClick} className="btn purple">
                Start a message
                <i className="fa-solid fa-forward" aria-hidden="true"></i>
              </button>

              <div className="flex project-links-cont center-it">
                {myLinks.map((items) => (
                  <a
                    key={items.id}
                    href={items.links}
                    className="project-links contact-links"
                    aria-label={items.label}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className={items.icons} aria-hidden="true"></i>
                  </a>
                ))}
              </div>
            </motion.div>

            <motion.div className="contact-sub-div-2" variants={leftVariant}>
              <Form nameRef={nameRef} />
            </motion.div>
          </FlatCard>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactForm;
